import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputLabel } from '@wajeez-web/components/ui';
import { UploadFileFormType } from '../Types';
import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { MediaHelpers } from '@wajeez-web/core/api';
import { Upload, UploadFile } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';

export interface FormUploadImageInputProps<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields> {
  fieldType: UploadFileFormType;
  disabled?: boolean;
}

const FormUploadImageInput = <TFormFields extends FieldValues>({
  fieldType,
  disabled,
  ...props
}: FormUploadImageInputProps<TFormFields>) => {
  const { field, fieldState } = useController({
    ...props,
    rules: {
      required: fieldType.required ? 'Required' : undefined,

      ...props.rules,
    },
  });

  const { t } = useTranslation();

  const InputRef = React.createRef<HTMLInputElement>();
  const [src, setSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const uploadFile = async (file: UploadFile<any>) => {
    setIsLoading(true);
    try {
      const uploadMethod =
        fieldType.fieldOptions.uploadEndPoint === 'Public'
          ? MediaHelpers.uploadPublicMedia
          : MediaHelpers.uploadMedia;

      console.log(typeof file);

      const res = await uploadMethod({
        data: file.originFileObj,
        fileName: file.name,
      });

      field.onChange(res);
      field.onBlur();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const onPreview = async (file: UploadFile) => {
    let src = file.url;
    if (!src && file.originFileObj != undefined) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as Blob);
        reader.onload = () => resolve(reader.result as string);
      });
    }
    const image = new Image();
    image.src = src ?? '';
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onChange = async (e: UploadChangeParam<UploadFile<any>>) => {
    const file = e.fileList?.[0];

    if (file) {
      await uploadFile(file);
    }
  };

  useEffect(() => {
    if (field.value) {
      MediaHelpers.getPublicMediaByIdAsync(field.value)
        .then((res) => {
          setSrc(res);
        })
        .catch(() => {
          setSrc('');
        });
    } else setSrc('');
  }, [field.value]);

  const isError = fieldState.error && fieldState.isTouched;
  return (
    <div
      className={`flex flex-col justify-center rtl:items-start ltr:items-end ${
        isError ? 'border-red-500' : ''
      }  `}
    >
      {fieldType.label && (
        <InputLabel
          text={
            t(
              `inputs.labels.${fieldType.label}`,
              fieldType.label.toString() || ''
            ) as string
          }
          name={field.name}
          required={fieldType.required}
          hint={fieldType.span}
        />
      )}
      {/* <ImgCrop rotate> */}
      <div>
        <Upload
          disabled={disabled}
          accept="image/*"
          // action={async (file: any) => {
          //   const formData = new FormData();

          //   formData.append('file', file as Blob);
          //   if (file) {
          //     await uploadFile(file);
          //   }

          //   return '';
          // }}
          listType="picture-card"
          fileList={
            isNullOrEmpty(src)
              ? []
              : [
                  {
                    uid: src,
                    name: src,
                    url: src,
                  },
                ]
          }
          onChange={(e) => {
            console.log(e);
            onChange(e);
          }}
          onRemove={() => {
            field.onChange(null);
            setSrc('');
          }}
          onPreview={onPreview}
          className="input"
        >
          {isNullOrEmpty(src) &&
            t(`inputs.labels.${'Upload +'}`, '').toString()}
        </Upload>
      </div>
      {/* </ImgCrop> */}
    </div>
  );
};

export default FormUploadImageInput;

// check if string null or undefined or empty
export const isNullOrEmpty = (str: string | undefined | null) => {
  return str == null || str === undefined || str === '';
};
